import { Container, Grid } from "@material-ui/core";
import React from "react";
import "./Solution.css";
import ReactDOM from 'react-dom';
import Box from '@material-ui/core/Box';

import Button from '@mui/material/Button';
import HowIiWorksTab from './HowIiWorksTab';
import Link from "@material-ui/core/Link";
export default function Solutions({
  handleScroll = () => {}
}) {
  return( 
    <>
 {/*Start banner section */}
  <div className="CommonBanner">
        <div className="CommonBannerImg">
            <img src="Images/Solution_Page_banner.jpg" alt="About-Dori" width="100%" height="100%" decoding="async" loading="lazy"></img>
        </div>
        <div className="custom-container CommonBannerContent">
                <h1 className="h1-heading padding-bottom-16 font-black">Enabling <span className="text-green"> Digital Transformations </span> for Enterprises</h1>
                <p className="subtitle padding-bottom-30 font-regular">Dori AI provides enterprises with a suite of applications to address the needs of productivity, compliance, quality, and safety</p>
                <Button variant="contained" className="rounded-white-btn" onClick={() => handleScroll('contact')}><span>Request Demo</span></Button>
        </div>
  </div>
{/*end banner section */}
{/* Visual Intelligence Platform for Enterprise Start */}
<div className="company-values Intelligence-Platform">
		<Grid container className="custom-container  section-padding-top">
          <Grid container direction="row" alignItems="center" className="vertical-center" item md={12} xl={12} xs={12}>
                <h2 className=" text-center h2-heading platform-max-width padding-bottom-36 font-black text-blue"><span class="text-green">Artificial Intelligence Platform </span>for Enterprise</h2>
          </Grid>
          <Grid container className="grid-outer">
                <Grid  variant="outlined" item md={4} xl={4} xs={12} style={{backgroundColor:'#ffffff'}}>
                                          
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="eye" className="svg-inline--fa fa-eye svg-icon-color-blue margin-bottom-20 " role="img"  viewBox="0 0 576 512"><path fill="currentColor" d="M572.5 238.1C518.3 115.5 410.9 32 288 32S57.69 115.6 3.469 238.1C1.563 243.4 0 251 0 256c0 4.977 1.562 12.6 3.469 17.03C57.72 396.5 165.1 480 288 480s230.3-83.58 284.5-206.1C574.4 268.6 576 260.1 576 256C576 251 574.4 243.4 572.5 238.1zM432 256c0 79.45-64.47 144-143.9 144C208.6 400 144 335.5 144 256S208.5 112 288 112S432 176.5 432 256zM288 160C285.7 160 282.4 160.4 279.5 160.8C284.8 170 288 180.6 288 192c0 35.35-28.65 64-64 64C212.6 256 201.1 252.7 192.7 247.5C192.4 250.5 192 253.6 192 256c0 52.1 43 96 96 96s96-42.99 96-95.99S340.1 160 288 160z"></path></svg>  
                          <h4 className="h4-heading padding-bottom-14 text-blue font-bold">Site Visibility</h4>
                          <p className="text-blue-faint subtitle">Monitor workforce movements and activities to improve productivity</p>
                </Grid>

                <Grid  variant="outlined" item md={4} xl={4} xs={12} style={{backgroundColor:'#ffffff'}}>
                                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="display" className="svg-inline--fa fa-user-group svg-icon-color-blue margin-bottom-20 svg-inline--fa fa-display"  role="img"  viewBox="0 0 576 512"><path fill="currentColor" d="M528 0h-480C21.5 0 0 21.5 0 48v320C0 394.5 21.5 416 48 416h192L224 464H152C138.8 464 128 474.8 128 488S138.8 512 152 512h272c13.25 0 24-10.75 24-24s-10.75-24-24-24H352L336 416h192c26.5 0 48-21.5 48-48v-320C576 21.5 554.5 0 528 0zM512 352H64V64h448V352z"></path></svg>
                          <h4 className="h4-heading padding-bottom-14 text-blue font-bold">Process Monitoring</h4>
                          <p className="text-blue-faint subtitle">Ensure all SOPs and inspections are compliant and measure efficiency</p>
                </Grid>
                <Grid  variant="outlined" item md={4} xl={4} xs={12} style={{backgroundColor:'#ffffff'}}>
                <svg  viewBox="0 0 576 512" className="svg-icon-color-blue margin-bottom-20"><path d="M517.5 168.6L139.2 2.266C124.4-3.609 107.5 2.266 99.62 16.14l-95.37 166.9C-.4999 191.3-1.25 201 1.999 209.9c3.25 8.875 10.25 15.87 19.13 19.12l156.5 64.87l-39.87 106.1H63.1c0-26.51-21.49-47.98-47.1-47.98C7.163 352 0 359.2 0 368v127.1C0 504.8 7.163 512 15.1 512c26.51 0 47.1-21.49 47.1-47.1l96.05 0c13.33 0 25.26-8.268 29.94-20.75l46.87-124.1l68.5 28.37c9.25 3.375 19.5 2.375 27.87-2.875l189.2-118.4C544.7 211.5 541.7 178.3 517.5 168.6zM565.9 273.8l-35.37-15.5l-138.4 86.5l119.5 52.51c8.5 3.75 18.46-.132 22.21-8.632l40.74-92.62c1.75-4.125 1.878-8.756 .2534-12.88C573.2 278.9 569.1 275.6 565.9 273.8z"/></svg>
                          <h4 className="h4-heading padding-bottom-14 text-blue font-bold">Production Monitoring</h4>
                          <p className="text-blue-faint subtitle">Detect and flag all risks and hazards before they escalate</p>
                </Grid>
          </Grid>
		</Grid>
		</div>
{/* Visual Intelligence Platform for Enterprise End */}
{/* Start Key-Use-Cases*/}
<div className="custom-container section-padding-top Key-Use-Cases  section-padding-bottom">
				<Grid container className="" >
					<Grid  item  item md={12} xl={12} xs={12} className="vertical-center text-center"  alignItems="center"  >
						<div className="center-subheading padding-bottom-36">		
							<h2 className="h2-heading font-black padding-bottom-16 text-blue" >Key Use Cases</h2>
						    <p className="subtitle font-regular text-blue-faint">Extract the business value out of your visual data and turn images and videos into real-time operational insights powered by AI and computer vision without the need for a large data science or engineering team. </p>
						</div>
					</Grid>
				<Grid  container spacing={3}>
				<Grid  item  item md={6} xl={6} sm={12}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1">
									<img height="100%" width="100%"className="desktop" src="Images\Visual_Quality_Inspection.jpg" alt="Visual Quality Inspection" decoding="async" loading="lazy"></img>
									<img height="100%" width="100%"className="mobile" src="Images\Visual_Quality_Inspection_mobile.jpg" alt="Visual Quality Inspection" decoding="async" loading="lazy"></img>
								</Box>
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="subtitle font-black padding-bottom-16 text-blue" >Customer Traffic</h4>
										<p className="subtitle2 font-regular text-blue-faint ">Monitor queue lengths, wait times, and hot spots in order to better serve customers</p>
									    <div className="border-inner"></div>
										<Link href="/contact" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={6} xl={6} sm={12}xs={12} className="vertical-center"  alignItems="center"  >
					    <div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
								<Box  order={1}  className="trusted-box1">
									<img height="100%" width="100%"className="desktop" src="Images\Workforce_Productivity_Monitoring.jpg" alt="Workforce Productivity Monitoring" decoding="async" loading="lazy"></img>
									<img height="100%" width="100%"className="mobile" src="Images\Workforce_Productivity_Monitoring_mobile.jpg" alt="Workforce Productivity Monitoring" decoding="async" loading="lazy"></img>
								</Box>
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="subtitle font-black padding-bottom-16 text-blue" >Workforce Productivity Monitoring</h4>
										<p className="subtitle2 font-regular text-blue-faint"> Monitor presence and time spent of workforce at each location or area to ensure smooth operations
</p>
										 <div className="border-inner"></div>
										<Link href="/contact" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
			   		 <Grid  item  item md={6} xl={6} sm={12}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
								<Box  order={1} className="trusted-box1">
									<img height="100%" width="100%"className="desktop" src="Images\Assembly_OP_Compliance.jpg" alt="Assembly OP Compliance" decoding="async" loading="lazy"></img>
									<img height="100%" width="100%"className="mobile" src="Images\Assembly_SOP_Compliance_mobile.jpg" alt="Assembly OP Compliance" decoding="async" loading="lazy"></img>
								</Box>
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="subtitle font-black padding-bottom-16 text-blue" >Process Compliance</h4>
										<p className="subtitle2 font-regular text-blue-faint ">Validate sequence and correctness of operations and flag alerts for any violations</p>
										<div className="border-inner"></div>
										<Link href="/contact" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={6} xl={6} sm={12}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1">
									<img height="100%" width="100%"className="desktop" src="Images\Asset-Equipment-Utilization.jpg" alt="Asset Equipment Utilization" decoding="async" loading="lazy"></img>
									<img height="100%" width="100%"className="mobile" src="Images\Asset_Equipment_Utilization_mobile.jpg" alt="Asset Equipment Utilization" decoding="async" loading="lazy"></img>
								</Box>
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="subtitle font-black padding-bottom-16 text-blue" >Resource Utilization</h4>
										<p className="subtitle2 font-regular text-blue-faint ">Monitor idle personnel or equipment to reduce on-site workforce and/or capital expenditures</p>
										<div className="border-inner"></div>
										<Link href="/contact" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					
				</Grid>
				</Grid>
			</div>
{/* End Key-Use-Cases*/}
{/* Our Key Results Start */}
<div className="Key_Results" style={{ backgroundImage: 'url("../Images/gray-dotted-bg.jpg") '}}>
			<Grid container className="custom-container padding-bottom-96 padding-top-96">
				<Grid container direction="row" alignItems="center" className="vertical-center" item md={12} xl={12} xs={12}>
							<h2 className=" text-center h2-heading company-max-width padding-bottom-30 text-c font-black text-blue">Delivering <span class="text-green">Key Results </span>for Enterprises</h2>
				</Grid>
				<Grid  container spacing={3}>
				 <Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1 vertical-center">
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="gears" className=" gear svg-icon-color-blue svg-inline--fa fa-gears" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M314.6 216.6L285.6 199.9C287.1 192.1 288 184.2 288 176.1C288 167.8 287.1 159.8 285.6 151.1L314.6 135.2c4.293-2.48 6.445-7.695 4.883-12.4C312.2 100.1 300.6 81.11 285.7 64.28C283.7 62.03 280.9 60.87 278 60.87c-1.861 0-3.736 .4785-5.42 1.449L243 79.41C231 69.11 217.3 61.07 202.1 55.75V21.65c0-4.943-3.418-9.348-8.258-10.36C182.9 9.002 171.6 7.67 160 7.67c-11.61 0-22.88 1.342-33.81 3.632c-4.84 1.016-8.248 5.41-8.248 10.35v34.09C102.7 61.07 88.96 69.11 76.98 79.41L47.39 62.32C45.71 61.35 43.83 60.87 41.97 60.87c-2.893 0-5.648 1.169-7.652 3.427C19.39 81.12 7.758 100.1 .5078 122.8C-1.053 127.5 1.098 132.7 5.391 135.2l29.04 16.77C32.93 159.8 32 167.8 32 176.1c0 8.137 .9434 16.04 2.395 23.75L5.391 216.6C1.098 219.1-1.053 224.3 .5078 228.1c7.25 21.83 18.79 41.69 33.71 58.52C36.22 289.8 39.08 290.9 41.97 290.9c1.861 0 3.738-.4785 5.42-1.449L76.7 272.6c12.04 10.41 25.91 18.53 41.24 23.89v33.69c0 4.941 3.419 9.279 8.258 10.29C137.1 342.7 148.4 344.1 160 344.1c11.61 0 22.88-1.411 33.81-3.7c4.84-1.016 8.247-5.343 8.247-10.28V296.5c15.34-5.365 29.2-13.49 41.24-23.9L272.6 289.5c1.68 .9707 3.559 1.449 5.42 1.449c2.891 0 5.646-1.238 7.652-3.498c14.92-16.83 26.56-36.6 33.81-58.44C321.1 224.3 318.9 219.1 314.6 216.6zM160 224.1c-26.51 0-48-21.49-48-48s21.49-48 48-48s48 21.49 48 48S186.5 224.1 160 224.1zM628.5 318.2c-1.016-4.84-5.412-8.248-10.36-8.248h-34.09c-5.324-15.22-13.36-28.98-23.66-40.96l17.09-29.6c.9707-1.68 1.449-3.559 1.449-5.42c0-2.893-1.167-5.648-3.425-7.652c-16.83-14.92-36.67-26.56-58.51-33.81c-4.703-1.561-9.918 .5898-12.4 4.883l-16.77 29.04C479.1 224.9 471.1 224 463.7 224c-8.137 0-16.04 .9434-23.75 2.395L423.2 197.4c-2.48-4.293-7.699-6.443-12.4-4.883c-21.83 7.25-41.69 18.79-58.52 33.71c-2.26 2.004-3.419 4.857-3.419 7.748c0 1.861 .4795 3.738 1.45 5.42l16.92 29.31c-10.41 12.04-18.53 25.91-23.89 41.24H309.6c-4.941 0-9.496 3.393-10.51 8.232C296.8 329.1 295.7 340.4 295.7 352c0 11.61 1.184 22.9 3.473 33.82C300.1 390.7 304.7 394.1 309.6 394.1h33.69c5.365 15.34 13.49 29.2 23.9 41.24l-16.92 29.31c-.9707 1.68-1.45 3.559-1.45 5.42c0 2.891 1.044 5.742 3.304 7.748c16.83 14.92 36.8 26.46 58.63 33.71c4.703 1.562 9.922-.5898 12.4-4.883l16.74-29C447.6 479.1 455.5 480 463.7 480c8.268 0 16.3-.9336 24.13-2.432l16.77 29.04c2.48 4.293 7.695 6.445 12.4 4.883c21.84-7.25 41.69-18.9 58.52-33.82c2.258-2.006 3.414-4.751 3.414-7.642c0-1.861-.4785-3.736-1.449-5.42l-17.09-29.6c10.29-11.98 18.34-25.74 23.66-40.96h34.09c4.943 0 9.35-3.418 10.37-8.258C630.8 374.9 632.1 363.6 632.1 352C632.1 340.4 630.8 329.1 628.5 318.2zM463.7 400c-26.51 0-48-21.49-48-48s21.49-48 48-48s48 21.49 48 48S490.2 400 463.7 400z"></path></svg>
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-trend-up" className=" increase svg-icon-color-blue svg-inline--fa fa-arrow-trend-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M384 160C366.3 160 352 145.7 352 128C352 110.3 366.3 96 384 96H544C561.7 96 576 110.3 576 128V288C576 305.7 561.7 320 544 320C526.3 320 512 305.7 512 288V205.3L342.6 374.6C330.1 387.1 309.9 387.1 297.4 374.6L191.1 269.3L54.63 406.6C42.13 419.1 21.87 419.1 9.372 406.6C-3.124 394.1-3.124 373.9 9.372 361.4L169.4 201.4C181.9 188.9 202.1 188.9 214.6 201.4L320 306.7L466.7 159.1L384 160z"></path></svg>
								
								</Box>
								<Box  order={2} className="trusted-box2 vertical-center">
									<div className="inner-text">		
									 	<p className="h4-heading font-regular text-blue ">Increased Operational Effeciency</p>
									</div>							
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1 vertical-center">
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-mixed" className="gear svg-icon-color-blue svg-inline--fa fa-chart-mixed" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M339.1 216.1C328.6 226.1 312.5 226.4 300.8 217.6L192.6 136.5L51.99 248.1C38.19 260 18.05 257.8 7.013 243.1C-4.028 230.2-1.79 210.1 12.01 199L172 71.01C183.4 61.9 199.5 61.65 211.2 70.4L319.4 151.5L460 39.01C473.8 27.97 493.9 30.21 504.1 44.01C516 57.81 513.8 77.95 499.1 88.99L339.1 216.1zM160 256C160 238.3 174.3 224 192 224C209.7 224 224 238.3 224 256V448C224 465.7 209.7 480 192 480C174.3 480 160 465.7 160 448V256zM32 352C32 334.3 46.33 320 64 320C81.67 320 96 334.3 96 352V448C96 465.7 81.67 480 64 480C46.33 480 32 465.7 32 448V352zM352 320V448C352 465.7 337.7 480 320 480C302.3 480 288 465.7 288 448V320C288 302.3 302.3 288 320 288C337.7 288 352 302.3 352 320zM416 256C416 238.3 430.3 224 448 224C465.7 224 480 238.3 480 256V448C480 465.7 465.7 480 448 480C430.3 480 416 465.7 416 448V256z"></path></svg>
								</Box>
								<Box  order={2} className="trusted-box2 vertical-center">
									<div className="inner-text">		
									 	<p className="h4-heading font-regular text-blue ">Higher Production Yields</p>
									</div>							
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1 vertical-center">
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="medal" className=" gear svg-icon-color-blue svg-inline--fa fa-medal" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M223.7 130.8L149.1 7.77C147.1 2.949 141.9 0 136.3 0H16.03c-12.95 0-20.53 14.58-13.1 25.18l111.3 158.9C143.9 156.4 181.7 137.3 223.7 130.8zM256 160c-97.25 0-176 78.75-176 176S158.8 512 256 512s176-78.75 176-176S353.3 160 256 160zM348.5 317.3l-37.88 37l8.875 52.25c1.625 9.25-8.25 16.5-16.63 12l-46.88-24.62L209.1 418.5c-8.375 4.5-18.25-2.75-16.63-12l8.875-52.25l-37.88-37C156.6 310.6 160.5 299 169.9 297.6l52.38-7.625L245.7 242.5c2-4.25 6.125-6.375 10.25-6.375S264.2 238.3 266.2 242.5l23.5 47.5l52.38 7.625C351.6 299 355.4 310.6 348.5 317.3zM495.1 0H375.7c-5.621 0-10.83 2.949-13.72 7.77l-73.76 122.1c42 6.5 79.88 25.62 109.5 53.38l111.3-158.9C516.5 14.58 508.9 0 495.1 0z"></path></svg>
								</Box>
								<Box  order={2} className="trusted-box2 vertical-center">
									<div className="inner-text">		
									 	<p className="h4-heading font-regular text-blue ">Improved Product Quality</p>
									</div>							
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1 vertical-center">
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-line-down" className=" gear svg-icon-color-blue svg-inline--fa fa-chart-line-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M64 400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32C49.67 32 64 46.33 64 64V400zM281.4 121.4C293.9 108.9 314.1 108.9 326.6 121.4L406.6 201.4L439 168.1C454.1 153.9 480 164.6 480 185.9V296C480 309.3 469.3 320 456 320H345.9C324.6 320 313.9 294.1 328.1 279L361.4 246.6L304 189.3L230.6 262.6C218.1 275.1 197.9 275.1 185.4 262.6L105.4 182.6C92.88 170.1 92.88 149.9 105.4 137.4C117.9 124.9 138.1 124.9 150.6 137.4L207.1 194.7L281.4 121.4z"></path></svg>
								</Box>
								<Box  order={2} className="trusted-box2 vertical-center">
									<div className="inner-text">		
									 	<p className="h4-heading font-regular text-blue ">Decreased Downtime</p>
									</div>							
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box ">
								<Box  order={1} className="trusted-box1 vertical-center">
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up-big-small" className=" gear svg-icon-color-blue svg-inline--fa fa-arrow-up-big-small" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M416 320h-96c-17.6 0-32 14.4-32 32v96c0 17.6 14.4 32 32 32h96c17.6 0 32-14.4 32-32v-96C448 334.4 433.6 320 416 320zM480 32h-160c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V64C512 46.33 497.7 32 480 32zM151.6 41.95c-12.12-13.26-35.06-13.26-47.19 0l-87.1 96.09C4.473 151.1 5.348 171.4 18.38 183.3c13.02 11.95 33.27 11.04 45.22-1.973L96 145.9v302C96 465.7 110.3 480 128 480s32-14.33 32-32.03V145.9L192.4 181.3c6.312 6.883 14.94 10.39 23.61 10.39c7.719 0 15.47-2.785 21.61-8.414c13.03-11.95 13.9-32.22 1.969-45.27L151.6 41.95z"></path></svg>								</Box>
								<Box  order={2} className="trusted-box2 vertical-center">
									<div className="inner-text">		
									 	<p className="h4-heading font-regular text-blue ">Increased Resource Utilization</p>
									</div>							
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1} className="trusted-box1 vertical-center">
								<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="triangle-exclamation" className=" gear svg-icon-color-blue svg-inline--fa fa-triangle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"></path></svg>
								</Box>
								<Box  order={2} className="trusted-box2 vertical-center">
									<div className="inner-text">		
									 	<p className="h4-heading font-regular text-blue ">Fewer Product Recalls</p>
									</div>							
								</Box>
							</Box>
						</div>
					</Grid>
					
				</Grid>
			</Grid>
				
		</div>
{/* Our Company Values Section End */}
{/* Start  Simplified section*/}
<div className="custom-container  Simplified section-padding-top section-padding-bottom trusted-by-section">
				<Grid container className="" >
					<Grid  item  item md={12} xl={12} xs={12} className="vertical-center text-center"  alignItems="center"  >
						<div className="center-subheading padding-bottom-36">		
							<h2 className="h2-heading font-black padding-bottom-16 text-blue" >We have <span style={{color:"#45BEA0"}}> Simplified </span>the Tech</h2>
						    <p className="subtitle font-regular text-blue-faint">Dori AI provides a suite of template AI applications across a broad range of enterprise needs </p>
						</div>
					</Grid>
				<Grid  container spacing={3}>
					<Grid  item  item md={3} xl={3} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
					    <div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
									<img height="100%" width="100%"className="" src="Images\Real-Time-Feedback.svg" alt="Real Time Feedback"  decoding="async" loading="lazy"></img>
									<div className="inner-text">		
									 	<h4 className="h4-heading font-black padding-bottom-16 text-blue" >Real-Time Feedback</h4>
										<p className="subtitle2 font-regular text-blue-faint">24/7 live monitoring and alerts for line operators and managers</p>
										
									</div>
								
							</Box>
						</div>
					</Grid>
			   		 <Grid  item  item md={3} xl={3} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
								
									<img height="100%" width="100%"className="" src="Images\AI-Driven-Kaizen.svg" alt="AI Driven Kaizen" decoding="async" loading="lazy"></img>
																	
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="h4-heading font-black padding-bottom-16 text-blue" >AI-Driven Triage</h4>
										<p className="subtitle2 font-regular text-blue-faint ">Capture operator performance and key production metrics</p>
										
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={3} xl={3} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								
									<img height="100%" width="100%"className="" src="Images\Instant-Video-Replay.svg" alt="Instant Video Replay" decoding="async" loading="lazy"></img>
																
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="h4-heading font-black padding-bottom-16 text-blue" >Instant Video Replay</h4>
										<p className="subtitle2 font-regular text-blue-faint ">For on-the-spot root cause analysis and operator training</p>
										
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={3} xl={3} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								
									<img height="100%" width="100%"className="" src="Images\Intelligent-Visual-Search.svg" alt="Intelligent Visual Search" decoding="async" loading="lazy"></img>
									
								
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	<h4 className="h4-heading font-black padding-bottom-24 text-blue" >Intelligent Visual Search</h4>
										<p className="subtitle2 font-regular text-blue-faint ">Search visual metadata by site, line, station, employee shift for faster root cause analysis
</p>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
				</Grid>
				</Grid>
			</div>
{/* End trusted by section*/}
{/* how it works section start*/}
<div className="custom-container  ">
				<Grid container className="" >
					<Grid  item  item md={12} xl={12} xs={12} className="vertical-center text-center"  alignItems="center"  >
						<div className="center-subheading padding-bottom-60">		
							<h2 className="h2-heading font-black padding-bottom-16 text-blue" >How It Works</h2>
						    <p className="subtitle font-regular text-blue-faint">We have standardized the approach to build robust computer vision applications. With our platform, you can get to production with weeks (not months). Our no-code/low-code approach enables subject matter experts to quickly build and configure one of our AI application templates to service any use case.</p>
						</div>
					</Grid>
                </Grid>
               
				<HowIiWorksTab/>
                
                </div>
{/* how it works section End*/}
{/* Start trusted by section*/}

{/* start case study section*/}
			{/*<div className="custom-container section-padding-top case-study" id="casestudy">
				<Grid container className="text-center">
					<Grid  item  item md={12} xl={12} xs={12} className="vertical-center"  alignItems="center"  >
						<div className="center-subheading padding-bottom-36">		
							<h2 className="h2-heading font-black padding-bottom-16 text-blue" >Case Studies</h2>
						    <p className="subtitle font-regular text-blue-faint">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore.</p>
						</div>
					</Grid>
				</Grid>
				<Grid container className="case-study-inner" spacing={3}>
					<Grid  item  item md={6} xl={6} sm={12} xs={12} className="vertical-center"  alignItems="center"  >
							
						<div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
								<Box  order={1}  className="box1">
								<img height="100%" width="100%"className="desktop" src="Images\Intelligent-visual-inspection-of-assembly-SOPs.jpg" alt="Intelligent visual inspection of assembly SOPs"></img>
									<img height="100%" width="100%"className="mobile" src="Images\manager-engineer-touch-screen-control-automation-robot-mobile.png" alt="Intelligent visual inspection of assembly SOPs"></img>
								</Box>
								<Box  order={2}  className="box2">
									<div className="inner-text">		
										<h4 className="subtitle font-black padding-bottom-16 text-blue" >Intelligent visual inspection of assembly SOPs</h4>
										<p className="subtitle2 font-regular text-blue-faint">Capturing the actions of each assembly operation from an engine transmission assembly station and automatically flagged.</p>
										<div >
											<ul >
											<li>
												<p className="subtitle font-black padding-bottom-9 text-blue ">50%</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint ">Reduction in maintenance costs  </p>
											</li>
											<li >
												<p className="subtitle font-black padding-bottom-9 text-blue">1M+</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint">Project completed successfully</p>
											</li>
											<li >
												<p className="subtitle font-black padding-bottom-9 text-blue">17</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint">Years of experience</p>
											</li>
											<li >
												<p className="subtitle font-black padding-bottom-9 text-blue">1000</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint">We work with the trusted clients</p>
											</li>
											</ul>
										</div>
										<div className="border"></div>
										<a href="#popup1" className="subtitle2 font-bold case-study-anchor link-animation">Contact Us</a>
									</div>
								</Box>
							</Box>
						</div>
						
					</Grid>
					<Grid  item  item md={6} xl={6} sm={12} xs={12} className="vertical-center"  alignItems="center"  >
					<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								<Box  order={1}  className="box1">
									<img height="100%" width="100%"className="desktop" src="Images\Intelligent-visual-inspection-of-assembly-SOPs.jpg" alt="Intelligent visual inspection of assembly SOPs"></img>
									<img height="100%" width="100%"className="mobile" src="Images\manager-engineer-touch-screen-control-automation-robot-mobile.png" alt="Intelligent visual inspection of assembly SOPs"></img>
								</Box>
								<Box  order={2}  className="box2">
									<div className="inner-text">		
										<h4 className="subtitle font-black padding-bottom-16 text-blue" >Intelligent visual inspection of assembly SOPs</h4>
										<p className="subtitle2 font-regular text-blue-faint">Capturing the actions of each assembly operation from an engine transmission assembly station and automatically flagged.</p>
										<div >
											<ul >
											<li>
												<p className="subtitle font-black padding-bottom-9 text-blue ">50%</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint ">Reduction in maintenance costs  </p>
											</li>
											<li >
												<p className="subtitle font-black padding-bottom-9 text-blue">1M+</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint">Project completed successfully</p>
											</li>
											<li >
												<p className="subtitle font-black padding-bottom-9 text-blue">17</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint">Years of experience</p>
											</li>
											<li >
												<p className="subtitle font-black padding-bottom-9 text-blue">1000</p>
												<p className="list-subtitle font-regular padding-bottom-14 text-blue-faint">We work with the trusted clients</p>
											</li>
											</ul>
										</div>
										<div className="border"></div>
										
										<a href="#popup1" className="subtitle2 font-bold case-study-anchor link-animation">Contact Us</a>
										{/*form start*/}
									{/*	<div id="popup1" className="overlay  contact-us-section section-padding-bottom">
				                            <Grid container className="popup" >
			        
												<Grid  item  item md={5} xl={5} xs={12} className="contact-inner"  alignItems="center"  >
												    <a class="close" href="#casestudy">&times;</a>
													<h2 className="h2-heading text-white font-black padding-bottom-20">Contact Us</h2>
													<p className="subtitle font-regular text-white padding-bottom-36">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore.sed diam nonumy eirmod tempor invidunt ut labore.</p>
													<form  >
														<div class="form-row">
															<div class="form-col form-control">
																<input type="text" id="standard-basic" placeholder="First Name" className="subtitle2 font-regular text-white"/>
																<input type="text" placeholder="Last  Name" className="subtitle2 font-regular text-white"  />
															</div>
															<div class=" form-control">
																<input type="text" placeholder="Business Email*" Type="email" className="subtitle2 font-regular text-white" />
															</div>
															<div class="form-control">
																<input type="text" placeholder="Company Name*"   className="subtitle2 font-regular text-white" />
															</div>
															<div class="form-col form-control">
																<input type="text" placeholder="Job Title*"className="subtitle2 font-regular text-white" />
																<input type="text" placeholder="Phone Number" Type="tel" className="subtitle2 font-regular text-white"/>
															</div>
															<div class=" form-control">
																<textarea placeholder="Message" className="subtitle2 font-regular text-white"></textarea>
															</div>
															<div class=" form-control">
																<Button variant="contained" className="rounded-white-btn"><span>Submit</span></Button>
															</div>
														</div>
													</form>
												</Grid>
											</Grid>
										</div>
										{/*End form*/}
									{/*</div>
								</Box>
							</Box>
						</div>
					</Grid>
					
				</Grid>
				<Grid  item  item md={12} xl={12} xs={12} className="text-center case-study-button" alignItems="center">
					<Button variant="contained" className="footer-btn "><span>Explore more Case Studies</span></Button>
					</Grid>
									</div>*/}
{/* end case study section*/}
{/* Our Trusted & Technology Partnerships Section Start */}
{/*<Grid container className="custom-container technology-partnerships section-container">
				<Grid container direction="row" alignItems="center" className="vertical-center" item md={12} xl={12} xs={12}>
					<h2 className="h2-heading padding-bottom-16 text-c font-black text-blue text-center">Our <span class="text-green"> Trusted & Technology </span>Partnerships</h2>
					<p className="subtitle text-blue center-subheading text-center padding-bottom-36 text-blue-faint font-regular" alignItems="center">Dori Ai is helping global brands to significantly increase human productivity & improve process compliances.</p>
				</Grid>
				<Grid container className="grid-outer">
					<Grid container variant="outlined" className="client-logo" item md={4} xl={4} xs={12}>
						<img src="Images/AWS.svg" alt="AWS" width="54px" height="32px"></img>
					</Grid>
					<Grid container variant="outlined" className="client-logo" item md={4} xl={4} xs={12}>
						<img src="Images/Microsoft Azure.svg" alt=" Azure" width="61px" height="33px"></img>
					</Grid>
					<Grid container variant="outlined" className="client-logo" item md={4} xl={4} xs={12}>
						<img src="Images/Google-cloud-platform-v2.svg" alt="Google-cloud-platform" width="37px" height="32px"></img>
					</Grid>
					<Grid container variant="outlined" className="client-logo" width="104px" height="20px" item md={4} xl={4} xs={12}>
						<img src="Images/NVIDIA.svg" alt="NVIDIA" ></img>
					</Grid>
					<Grid container variant="outlined" className="client-logo" width="54px" height="36px"  item md={4} xl={4} xs={12}>
						<img src="Images/intel.svg" alt="intel"></img>
					</Grid>
					<Grid container variant="outlined" className="client-logo" item md={4} xl={4} xs={12}>
						<img src="Images/Plug-and-Play.svg" alt="Plug-and-Play" width="96px" height="18px"></img>
					</Grid>
			    </Grid>
	</Grid>*/}
			{/* Our Trusted & Technology Partnerships Section End */}
			{/* Start  resources section*/}
{/*<div className="custom-container  Simplified section-padding-bottom trusted-by-section">
				<Grid container className="" >
					<Grid  item  item md={12} xl={12} xs={12} className="vertical-center text-center"  alignItems="center"  >
						<div className="center-subheading padding-bottom-36">		
							<h2 className="h2-heading font-black padding-bottom-16 text-blue" >Resources</h2>
						    <p className="subtitle font-regular text-blue-faint">Read more about how we are enabling our partners and customers with a seamless platform to build and deploy computer vision applications with ease. </p>
						</div>
					</Grid>
				<Grid  container spacing={5}>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
					    <div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
									<img height="100%" width="100%"className="" src="Images\blog3.jpg" alt="Real Time Feedback"></img>
									<div className="inner-text">		
									   <p className="subtitle2 font-black margin-bottom-10 text-blue">Dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
									   <p className="subtitle2 font-regular text-blue-faint">5 min. Read | 12 July 2021</p>
									   <div className="border-inner"></div>
										<Link to="#" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								
							</Box>
						</div>
					</Grid>
			   		 <Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box   className="box">
								
									<img height="100%" width="100%"className="" src="Images\blog1.jpg" alt="AI Driven Kaizen"></img>
																	
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
									 	
										<p className="subtitle2 font-black  text-blue margin-bottom-10 ">Dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
										<p className="subtitle2 font-regular text-blue-faint ">5 min. Read | 12 July 2021</p>
										<div className="border-inner"></div>
										<Link to="#" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					<Grid  item  item md={4} xl={4} sm={6}xs={12} className="vertical-center"  alignItems="center"  >
						<div style={{ width: '100%' }} className="box-inner">
							<Box  className="box">
								
									<img height="100%" width="100%"className="" src="Images\blog1.jpg" alt="Instant Video Replay"></img>
																
								<Box  order={2} className="trusted-box2">
									<div className="inner-text">		
											<p className="subtitle2 font-black  text-blue margin-bottom-10">Dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
											<p className="subtitle2 font-regular text-blue-faint ">5 min. Read | 12 July 2021</p>
										   <div className="border-inner"></div>
										   <Link to="#" className="subtitle2 font-bold case-study-anchor link-animation">Learn More</Link>
									</div>
								</Box>
							</Box>
						</div>
					</Grid>
					
				</Grid>
				</Grid>
</div>*/}
{/* End R section*/}
			{/* We are Nerd Section Start */}
	<Grid container direction="row" alignItems="center" className="vertical-center custom-container padding-top-96 padding-bottom-96 bg-pattern top-section-padding" style={{ 
		                           backgroundImage: `url("../Images/blue-dotted-bg.jpg")` }}>
							<h2 className="h1-heading padding-bottom-16 text-c font-black text-white text-center">We’re your <span class="text-green">AI Partner </span></h2>
							<p className="subtitle text-blue center-subheading text-center padding-bottom-30 text-white font-regular " alignItems="center">Reach out to us to find out more about how we can enable your enterprise with actionable visual intelligence and real-time operational insights.
              </p>
              <Button variant = "contained" className = "rounded-white-btn" onClick = { () => handleScroll('contact')}><span > Contact Us</span></Button>
							
				</Grid>
{/* We are Nerd Section end */}

    </>
  );
}